<template>
  <v-container id="mainfile" fluid tag="section">
    <v-row>
      <v-col cols="2">
        <v-btn color="primary" @click="$refs.mainfileAddDialog.dialog = true">
          {{ $t("add") }} {{ $t("main_file") }}
        </v-btn>
        <MainfileAddDialog ref="mainfileAddDialog"></MainfileAddDialog>
      </v-col>

      <v-col cols="2">
        <v-btn
          color="primary"
          @click="$refs.mainfileImportDialog.dialog = true"
        >
          {{ $t("import") }} {{ $t("main_file") }}
        </v-btn>
        <MainfileImportDialog ref="mainfileImportDialog"></MainfileImportDialog>
      </v-col>

      <v-col cols="2">
        <v-btn color="primary" @click="exportMainfilesFromCsv">
          {{ $t("export") }} {{ $t("main_file") }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card color="primary">
          <template v-slot:heading>
            <div class="display-2 font-weight-light">{{ $t("main_file") }}</div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-spacer></v-spacer>

                    <v-col cols="3">
                      <v-btn
                        @click="$refs.deleteItemsConfirmDialog.dialog = true"
                      >
                        {{ $t("delete") }}
                      </v-btn>

                      <ConfirmDialog
                        ref="deleteItemsConfirmDialog"
                        :repeatString="'delete'"
                        @doFunction="removeMainfiles(selected)"
                      ></ConfirmDialog>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <v-data-table
                    :headers="headers"
                    v-model="selected"
                    :items="mainfileItems"
                    item-key="_id"
                    :items-per-page="5"
                    :footer-props="{
                      showFirstLastPage: true,
                      firstIcon: 'mdi-arrow-collapse-left',
                      lastIcon: 'mdi-arrow-collapse-right',
                      prevIcon: 'mdi-minus',
                      nextIcon: 'mdi-plus',
                    }"
                    show-select
                  >
                    <template v-slot:[`item.action`]="{ item }">
                      <v-icon small @click="openMainfileUpdateDialog(item)">
                        mdi-pencil
                      </v-icon>

                      <v-icon
                        small
                        @click="$refs.deleteItemConfirmDialog.dialog = true"
                      >
                        mdi-delete
                      </v-icon>

                      <ConfirmDialog
                        ref="deleteItemConfirmDialog"
                        :repeatString="'delete'"
                        @doFunction="removeMainfiles([item])"
                      ></ConfirmDialog>
                    </template>
                  </v-data-table>
                </v-col>

                <v-col cols="12">
                  <MainfileUpdateDialog
                    ref="mainUpdateDialog"
                    :item="editItem"
                  ></MainfileUpdateDialog>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MainfileAddDialog from "@/components/mainfile/MainfileAddDialog";
import MainfileImportDialog from "@/components/mainfile/MainfileImportDialog";
import MainfileUpdateDialog from "@/components/mainfile/MainfileUpdateDialog";
import ConfirmDialog from "@/components/base/ConfirmDialog.vue";
import {
  getMainfiles,
  removeMainfiles,
  exportMainfilesFromCsv,
} from "@/endpoint/mainfile";

export default {
  name: "mainfile",
  components: {
    MainfileAddDialog,
    MainfileImportDialog,
    MainfileUpdateDialog,
    ConfirmDialog,
  },
  data() {
    return {
      headers: [
        { text: this.$t("licensePlate"), value: "license_plate" },
        { text: this.$t("channel"), value: "channel_uuid" },
        { text: this.$t("list_type"), value: "list_type" },
        { text: this.$t("area"), value: "area" },
        {
          text: this.$t("chinese") + " " + this.$t("name"),
          value: "chinese_name",
        },
        {
          text: this.$t("english") + " " + this.$t("name"),
          value: "english_name",
        },
        { text: this.$t("company"), value: "company" },
        { text: this.$t("department"), value: "department" },
        {
          text: this.$t("employee") + " " + this.$t("number"),
          value: "employee_number",
        },
        {
          text: this.$t("parking_space") + " " + this.$t("number"),
          value: "parking_space_number",
        },
        { text: this.$t("ID_number"), value: "ID_number" },
        { text: this.$t("phone"), value: "phone" },
        { text: this.$t("address"), value: "address" },
        {
          text: this.$t("time") + " " + this.$t("period"),
          value: "time_period",
        },
        {
          text: this.$t("parking") + " " + this.$t("type"),
          value: "parking_type",
        },
        {
          text: this.$t("extra_field") + "1",
          value: "extra_field_1",
        },
        {
          text: this.$t("extra_field") + "2",
          value: "extra_field_2",
        },
        {
          text: this.$t("extra_field") + "3",
          value: "extra_field_3",
        },
        { text: this.$t("action"), value: "action", sortable: false },
      ],
      selected: [],
      editItem: null,
      mainfileItems: [],
    };
  },
  created() {
    this.init(this);
  },
  methods: {
    exportMainfilesFromCsv: exportMainfilesFromCsv,
    async init(scope) {
      scope.mainfileItems = await getMainfiles();
    },
    removeMainfiles(mainfiles) {
      let deleteArray = [];

      mainfiles.forEach((mainfile) => {
        deleteArray.push(mainfile._id);
      });

      let data = {};
      if (deleteArray.length > 0) {
        data.mainfile_uuids = deleteArray;
      }

      removeMainfiles(data).then(() => {
        this.$router.go();
      });
    },
    openMainfileUpdateDialog(item) {
      this.editItem = item;
      this.$refs.mainUpdateDialog.dialog = true;
    },
  },
};
</script>
